export default "__VITE_ASSET__52d2f0ce__"